<!-- eslint-disable vue/valid-v-slot -->
/* eslint-disable no-const-assign */
<template>
  <v-container fluid class="caso-component">
    <v-flex xs12 class="text-center justify-center mb-4 mt-6">
      <h4 class="font-weight-bold">LISTA DE CLIENTES</h4>
    </v-flex>
    <v-card>
      <v-card-text>
        <filtros
          ref="criterios"
          :campos.sync="camposfiltros"
          @actualizarFiltro="getData"
          @nuevo="addUpdate"
        ></filtros>
      </v-card-text>
    </v-card>
    <v-data-table
      :headers="headers"
      :items="desserts"
      :options.sync="options"
      :loading="loading"
      class="elevation-1"
      :dense="true"
      no-data-text="Datos no disponibles"
      no-results-text="Cargando..."
      fixed-header
      :height="500"
      :footer-props="{
        'show-current-page': false,
        'show-first-last-page': false,
        'items-per-page-options': [],
        'items-per-page-text': '',
      }"
      :disable-sort="true"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <!-- <v-spacer></v-spacer>
          <v-btn
            small
            dark
            outlined
            color="primary"
            class="mr-2"
            title="Agregar"
            @click="addUpdate"
          >
            <v-icon>mdi-plus</v-icon>Nuevo
          </v-btn> -->
        </v-toolbar>
      </template>
      <template v-slot:footer.page-text>
        <v-row justify="end" align="center" class="ma-0 pa-0">
          <v-col class="col-content-footer">
            <v-btn
              type="button"
              :loading="loading"
              :disabled="paginas.length === 0"
              @click="getDataAnterior"
              class="v-btn v-btn--icon v-btn--round v-btn--text theme--light v-size--default"
              aria-label="Previous page"
            >
              <span class="v-btn__content">
                <i
                  aria-hidden="true"
                  class="v-icon notranslate mdi mdi-chevron-left theme--light"
                ></i>
              </span>
            </v-btn>
            <v-btn
              type="button"
              :loading="loading"
              :disabled="!ultimoDocumento"
              @click="getDataSiguiente"
              class="v-btn v-btn--icon v-btn--round v-btn--text theme--light v-size--default"
              aria-label="Next page"
            >
              <span class="v-btn__content">
                <i
                  aria-hidden="true"
                  class="v-icon notranslate mdi mdi-chevron-right theme--light"
                ></i>
              </span>
            </v-btn>
          </v-col>
        </v-row>
      </template>
      <template v-slot:[`item.estado`]="{ item }">
        <v-chip
          small
          :color="item.estado ? 'success' : 'secondary'"
          dark
          v-text="item.estado ? 'Activo' : 'Inactivo'"
        >
        </v-chip>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-icon small class="mr-4" title="Editar" @click="addUpdate(item)">
          mdi-pencil
        </v-icon>
        <v-icon small @click="inavilitar(item)" title="Inactivar">
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>
    <modal-add
      v-if="showModal"
      :showModal.sync="showModal"
      :id="id"
      @actualizar="getData"
    ></modal-add>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { db } from "../../firebase";
// import Paginado from "../../helpers/Paginado";
import ModalAdd from "./ModalAdd.vue";
import Filtros from "../General/Filtros.vue";
// import moment from "moment";

export default {
  components: {
    ModalAdd,
    Filtros,
  },
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Clientes",
  data() {
    return {
      coleccion: "clientes",
      totalItems: 0,
      lastVisible: "",
      itemsPerPage: 0,
      ordenar: "",
      typoOrdenar: false,
      page: 0,
      options: {},
      camposfiltros: [],
      criterios: [],
      search: "",
      loading: true,
      desserts: [],
      showModal: false,
      id: "",
      headers: [
        {
          text: "Nombres",
          filterable: true,
          align: "start",
          sortable: true,
          value: "nombres",
        },
        { text: "Apellidos", value: "apellidos" },
        { text: "Ciuadad", value: "ciudad" },
        { text: "Direccion", value: "direccion" },
        { text: "Identificacion", value: "identificacion" },
        { text: "Telefono", value: "telefono" },
        { text: "Tipo de Identificacion", value: "tipoidentificacion" },
        // { text: "Fecha Creacion", value: "creado" },
        { text: "Estado", value: "estado" },
        { text: "Action", value: "action" },
      ],
      condicion: {},
      ultimoDocumento: null,
      primerDocumento: null,
      unsubscribe: null,
      camposNumericos: ["identificacion"],
      querySnapshot: [],
      paginas: [],
    };
  },
  computed: {
    ...mapState(["drawer", "logueado"]),
    user() {
      return this.$store.getters.user;
    },
    autorizaCrear() {
      return this.logueado.cargo === "Call Center" ||
        this.logueado.cargo === "Coordinador Contact Center" ||
        this.logueado.cargo === "Administrador"
        ? true
        : false;
    },
  },
  async mounted() {
    this.headers.forEach((element) => {
      if (element.value !== "estado" && element.value !== "action") {
        this.camposfiltros.push({
          campo: element.value,
          etiqueta: element.text,
        });
      }
    });

    await this.getData();
  },
  beforeDestroy() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  },
  watch: {
    options: {
      async handler() {
        await this.filtros();
      },
      deep: true,
    },
  },
  methods: {
    async filtros() {
      const { sortBy, sortDesc } = this.options;
      this.ordenar = sortBy[0] || this.headers[0].value;
      this.typoOrdenar = sortDesc[0] ? "asc" : "desc";
      this.criterios = await this.$refs.criterios.enviarCriterios();

      if (this.criterios.length > 0 && this.criterios[0]?.valor) {
        this.criterios.forEach((element) => {
          if (element.campo && element?.valor) {
            this.campoFiltro = element.campo;
            this.operadorFiltro = element.operador;
            this.valorFiltro = element?.valor;
          }
        });
      }
    },
    async getData() {
      try {
        this.loading = true;
        await this.filtros();
        let consulta = db.collection(this.coleccion);

        if (this.criterios.length > 0 && this.criterios[0]?.valor) {
          consulta = consulta.where(
            this.campoFiltro,
            this.operadorFiltro,
            this.camposNumericos.includes(this.campoFiltro)
              ? parseInt(this.valorFiltro || 0)
              : this.valorFiltro?.toUpperCase().trim()
          );
        }

        if (!this.criterios[0]?.valor) {
          consulta = consulta.orderBy("creado", "desc");
        }
        consulta = consulta.limit(10);
        this.unsubscribe = consulta.onSnapshot((querySnapshot) => {
          this.querySnapshot = querySnapshot;
          this.procesarQuerySnapshot();
        });
      } catch (error) {
        console.log("error", error);
        this.handleError(error);
      }
    },
    async getDataSiguiente() {
      if (!this.ultimoDocumento) return;
      try {
        this.loading = true;
        await this.filtros();
        let consulta = db.collection(this.coleccion);

        if (this.criterios.length > 0 && this.criterios[0]?.valor) {
          consulta = consulta.where(
            this.campoFiltro,
            this.operadorFiltro,
            this.valorFiltro
          );
        } else {
          consulta = consulta.orderBy("creado", "desc");
        }

        consulta = consulta.limit(10).startAfter(this.ultimoDocumento);

        this.unsubscribe = consulta.onSnapshot((querySnapshot) => {
          if (!querySnapshot.empty) {
            this.querySnapshot = querySnapshot;
            this.paginas.push(this.primerDocumento);
            this.procesarQuerySnapshot();
          }
        });
      } catch (error) {
        console.error("Error al obtener datos siguientes:", error);
        this.handleError(error);
      }
    },
    async getDataAnterior() {
      if (this.paginas.length === 0) return;
      try {
        this.loading = true;
        await this.filtros();
        let consulta = db.collection(this.coleccion);

        if (this.criterios.length > 0 && this.criterios[0]?.valor) {
          consulta = consulta.where(
            this.campoFiltro,
            this.operadorFiltro,
            this.valorFiltro
          );
        } else {
          consulta = consulta.orderBy("creado", "desc");
        }

        const documentoAnterior = this.paginas.pop();
        consulta = consulta.limit(10).startAt(documentoAnterior);

        this.unsubscribe = consulta.onSnapshot((querySnapshot) => {
          if (!querySnapshot.empty) {
            this.querySnapshot = querySnapshot;
            this.procesarQuerySnapshot();
          }
        });
      } catch (error) {
        console.error("Error al obtener datos anteriores:", error);
        this.handleError(error);
      }
    },
    procesarQuerySnapshot() {
      const datos = this.querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      this.desserts = datos;
      this.ultimoDocumento =
        this.querySnapshot.docs[this.querySnapshot.docs.length - 1];
      this.primerDocumento = this.querySnapshot.docs[0];
      this.loading = false;
    },
    addUpdate(item = "") {
      if (!this.autorizaCrear) {
        this.$swal({
          icon: "info",
          title: "Oops...",
          text: "Usuario no autorizado",
        });
        return;
      }
      this.id = item.id;
      this.showModal = true;
    },
    inavilitar(item) {
      if (!this.autorizaCrear) {
        this.$swal({
          icon: "info",
          title: "Oops...",
          text: "Usuario no autorizado",
        });
        return;
      }
      this.$swal({
        title: "",
        text: "Esta seguro de eliminar este registro?",
        icon: "warning",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Si, Eliminar !!",
      }).then((result) => {
        if (result.value) {
          db.collection(this.coleccion).doc(item.id).update({ estado: false });
          this.getData();
          // const index = this.desserts.map((el) => el.id).indexOf(item);
          // this.desserts.splice(index, 1);
        }
      });
    },
    handleError({ message }) {
      this.$swal({ icon: "error", title: "Oops...", text: message });
      this.loading = false;
    },
  },
};
</script>

<style src="./Clientes.scss" lang="scss"></style>
